import gql from 'graphql-tag';

import { LegalDocCode } from '@/enums/user/LegalDocCode';

export namespace AcceptLegalDocs {

  export const mutation = gql`
    mutation ($codes: [LegalDocCode!]!) {
      acceptLegalAgreement(codes: $codes)
    }
  `;

  export interface VariablesDefinition {
    codes: LegalDocCode[];
  }

}
